// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectInput,
  ReferenceInput,
  ReferenceField,
  ReferenceArrayField,
  DateField

} from "react-admin";

import { JsonField, JsonInput } from "react-admin-json-view";

const RapportsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Rechercher par Id" source="id" alwaysOn />
    <SelectInput
      label="Recherche par type"
      source="type"
      choices={[
        { id: "Villa", name: "Villa" },
        { id: "Appartement", name: "Appartement" },
        { id: "Maison", name: "Maison" },
        { id: "Commerce", name: "Commerce" },
        { id: "Bureau", name: "Bureau" },
        { id: "Terrain", name: "Terrain" },
      ]}
      alwaysOn
    />
    {/* <TextInput
      label="Rechercher par region"
      source="geocoding.province"
      alwaysOn
    /> */}
    <TextInput label="Rechercher par userId" source="userId" alwaysOn />
  </Filter>
);

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

export const RapportsList = (props) => (
  <List {...props} filters={<RapportsFilter />} pagination={<PostPagination />}>
    <Datagrid>
      <TextField source="id" />
      <DateField source="date" />
      <TextField source="estimation.type" label="Type" />
      <JsonField
        source="estimation"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <JsonField
        source="geocoding"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <JsonField
        source="results"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <TextField
        source="userId"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <ReferenceField label="Agence" reference={`users`} source="userId">
        <TextField source="nomAgence" />
      </ReferenceField>
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const RapportsShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="estimation.type" label="Type" />
      <JsonField
        source="estimation"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <JsonField
        source="geocoding"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <JsonField
        source="results"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <TextField source="userId" />
    </SimpleShowLayout>
  </Show>
);

export const RapportsEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      <JsonInput
        source="geocoding"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <JsonInput
        source="results"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <JsonInput
        source="estimation"
        reactJsonOptions={{
          collapsed: true,
        }}
      />
      <ReferenceInput
        source="userId"
        reference={`users`}
        sort={{ field: "nomAgence", order: "ASC" }}
        perPage={100}
        alwaysOn
      >
        <SelectInput
          optionText="nomAgence"
          optionValue="id"
          resettable={true}
        />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
